import { useExplorerStore } from "@/FundExplorer/store";
import { hooks } from "hsl-core/FundExplorer";

export default function useActiveFiltersCount(subset?: string[]) {
	const activeFilters = hooks.useExplorerStore((store) => store.activeFilters);
	const selectedManagers = useExplorerStore((store) => store.selectedManagers);

	return Object.entries(activeFilters)
		.filter(([key]) => !subset || subset.includes(key))
		.reduce(
			(sum, [key, value]) =>
				["fund.profiles"].includes(key) && value.length > 0
					? sum + selectedManagers.length
					: value.length + sum,
			0,
		);
}
